var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 51 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60995 54.1014C2.8825 53.9731 2.22902 53.5796 1.7753 52.9967C1.3208 52.4137 1.09899 51.6836 1.15197 50.9467C1.2057 50.21 1.52956 49.5194 2.06206 49.0077L45.1421 7.63619C45.9113 6.89739 47.0172 6.62447 48.0421 6.92176C49.0663 7.21818 49.8558 8.03905 50.1109 9.07506C50.3665 10.1112 50.0502 11.2042 49.2809 11.9437L6.20091 53.3152C5.51285 53.9774 4.54951 54.27 3.60991 54.102L3.60995 54.1014Z",
    fill: "#6BAE61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.67 54.1637C46.7272 54.3315 45.7612 54.037 45.0725 53.3718L2.11444 11.8793C1.34698 11.1371 1.03267 10.0422 1.29163 9.00702C1.54971 7.97126 2.34104 7.15162 3.36735 6.85795C4.39353 6.56352 5.49862 6.8397 6.26668 7.58103L49.2251 49.0755C49.7547 49.5884 50.0763 50.2794 50.1275 51.015C50.1787 51.7507 49.9566 52.4793 49.5026 53.0607C49.0494 53.6419 48.3966 54.0353 47.6709 54.1648L47.67 54.1637Z",
    fill: "#6BAE61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cae52b3abf229cca07a059bb37a94df8.svg";
export { ForwardRef as ReactComponent };